import { faker } from '@faker-js/faker';
import type {
  CreateDeploymentAutomatorV2MutationResponseApi,
  DeploymentAutomatorResourceReadV2Api,
} from '@ingenico/api-sdk-device-management-private-v2';
import { HttpResponse } from 'msw';

export function generateDeploymentAutomatorReadV2Api(): DeploymentAutomatorResourceReadV2Api {
  return {
    id: faker.string.uuid(),
    creationDate: faker.date.past(),
    creator: {
      id: faker.string.uuid(),
      name: faker.person.fullName(),
    },
    description: faker.lorem.sentence(),
    name: faker.string.alphanumeric(100),
    status: 'DISABLED',
    triggers: [
      {
        deploymentRequestTrigger: {
          scheduleOption: {
            date: faker.date.past(),
            exclusionDates: [faker.date.past()],
            timeSlot: {
              endDate: faker.date.past(),
              startDate: faker.date.past(),
            },
          },
          type: 'AUTOMATIC',
        },
        type: 'MANUAL',
      },
    ],
    deploymentRequestOptions: {
      configurationReference: {
        id: faker.string.uuid(),
      },
    },
    dynamicGroupReference: {
      id: faker.string.uuid(),
    },
  };
}

export function createDeploymentAutomatorV2CustomHandler() {
  return HttpResponse.json<CreateDeploymentAutomatorV2MutationResponseApi>(generateDeploymentAutomatorReadV2Api());
}
